import { render, staticRenderFns } from "./OnlyFourNumberDetail.vue?vue&type=template&id=6120c606"
import script from "./OnlyFourNumberDetail.vue?vue&type=script&lang=js"
export * from "./OnlyFourNumberDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports